import { load } from '@fingerprintjs/fingerprintjs'

export async function getVisitorId() {
  const agent = await load()
  const { visitorId } = await agent.get()

  return visitorId
}
